var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 15,
    clipPath: "url(#clip0_705_5800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3917 15.3925L17.0834 14.1667C17.5352 14.0327 18.0174 14.0408 18.4645 14.1898C18.9117 14.3389 19.3022 14.6217 19.5834 15C9.39252 20.0942 12.69 20.0642 3.75002 17.0833L0.416687 19.1667",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91669 15.8333H12.5C12.6219 15.8552 12.7472 15.8501 12.8669 15.8183C12.9866 15.7866 13.0979 15.7289 13.1929 15.6494C13.2879 15.57 13.3643 15.4706 13.4167 15.3584C13.4692 15.2462 13.4964 15.1239 13.4964 15C13.4964 14.8761 13.4692 14.7538 13.4167 14.6416C13.3643 14.5294 13.2879 14.43 13.1929 14.3506C13.0979 14.2711 12.9866 14.2134 12.8669 14.1817C12.7472 14.1499 12.6219 14.1448 12.5 14.1667H10C9.01225 13.1475 7.66839 12.5503 6.25002 12.5H3.75002L0.416687 14.1667",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79584 5.95742C7.79584 6.63033 7.92838 7.29666 8.18589 7.91835C8.44341 8.54004 8.82085 9.10493 9.29667 9.58075C9.77249 10.0566 10.3374 10.434 10.9591 10.6915C11.5808 10.949 12.2471 11.0816 12.92 11.0816C13.5929 11.0816 14.2592 10.949 14.8809 10.6915C15.5026 10.434 16.0675 10.0566 16.5433 9.58075C17.0192 9.10493 17.3966 8.54004 17.6541 7.91835C17.9116 7.29666 18.0442 6.63033 18.0442 5.95742C18.0442 5.2845 17.9116 4.61818 17.6541 3.99648C17.3966 3.37479 17.0192 2.80991 16.5433 2.33409C16.0675 1.85826 15.5026 1.48082 14.8809 1.22331C14.2592 0.965792 13.5929 0.833252 12.92 0.833252C12.2471 0.833252 11.5808 0.965792 10.9591 1.22331C10.3374 1.48082 9.77249 1.85826 9.29667 2.33409C8.82085 2.80991 8.44341 3.37479 8.18589 3.99648C7.92838 4.61818 7.79584 5.2845 7.79584 5.95742Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.92 3.33333V2.5",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 3.33325H12.4758C12.2162 3.33343 11.9647 3.42395 11.7645 3.58928C11.5643 3.75461 11.4279 3.98444 11.3786 4.23937C11.3293 4.49429 11.3703 4.75841 11.4945 4.98644C11.6186 5.21446 11.8183 5.39217 12.0592 5.48909L13.7792 6.17742C14.02 6.27434 14.2197 6.45205 14.3439 6.68007C14.468 6.90809 14.509 7.17221 14.4597 7.42714C14.4105 7.68206 14.274 7.9119 14.0738 8.07722C13.8736 8.24255 13.6221 8.33307 13.3625 8.33325H11.6667",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.92 9.16659V8.33325",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_705_5800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.c6f0dc654b14da46000d39dd961fbaed.svg";
export { ForwardRef as ReactComponent };